import axios from 'axios';
import axiosRetry from 'axios-retry';

import { addAuthHeader, refreshExpiredToken } from './interceptors/authInterceptors.js';
import { checkResponseBody, checkErrorBody } from './interceptors/emptyBodyInterceptors.js';
import { handleResponseError, addCorrelationId } from './interceptors/errorInterseptors.js';
import { addNSureHeader } from './interceptors/nSureInterceptor.js';
import { addUserLocaleHeader } from './interceptors/userLocaleInterceptor';
import { addPartnerHeader } from "./interceptors/userPartnerIntercepor";
import { addCsrfHeader } from "./interceptors/csrfInterceptors";

const noopSuccess = Promise.resolve.bind(Promise);
const noopFail = Promise.reject.bind(Promise);

// TODO copied from Widget repo, should be replaced with centralized client
// @see https://gitlab.com/techcloud/pb/widget-front/-/blob/master/src/network/client.js
const instance = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

axiosRetry(instance, {
  retries: 1,
  retryDelay: retryCount => retryCount * 500,
});

// order matters
instance.interceptors.request.use(addAuthHeader, noopFail);
instance.interceptors.request.use(addCorrelationId, noopFail);
instance.interceptors.request.use(addNSureHeader, noopFail);
instance.interceptors.request.use(addUserLocaleHeader, noopFail);
instance.interceptors.request.use(addPartnerHeader, noopFail);
instance.interceptors.request.use(addCsrfHeader, noopFail);

instance.interceptors.response.use(checkResponseBody, checkErrorBody);
instance.interceptors.response.use(noopSuccess, refreshExpiredToken.bind(instance));
instance.interceptors.response.use(noopSuccess, handleResponseError);

export default instance;
